import AddressProofError from './AddressProofError';
class ThereIsNoAddressProofToCorrect extends AddressProofError {
    constructor(options) {
        super('Investor does not have address proof to correct', options);
    }
}
export default ThereIsNoAddressProofToCorrect;
